import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

interface KineticWordProps {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}

export function KineticWord({ children, delay = 600, className }: KineticWordProps) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  return (
    <span className="inline-block overflow-hidden">
      <span
        className={cn(
          "inline-block transition-all duration-700 ease-out",
          isVisible
            ? "translate-x-0 opacity-100"
            : "translate-x-[-100%] opacity-0",
          className
        )}
      >
        {children}
      </span>
    </span>
  );
}
